// extracted by mini-css-extract-plugin
module.exports = {"container":"EndSession__container__-jd4A","header":"EndSession__header__ecDCS typography__h2__33H9K"};